import { createStore } from 'vuex';
import cartHelpers from './api';
const { status, fetch,fetchExtraData, add, update, change, updateNote, clear } = cartHelpers;
const req = (api, data) => {
  return new Promise(resolve => {
    api(data).then(data => {
      resolve(data);
    });
  });
};

const afterReq = (data, commit, getters) => {
  commit('setCart', data);

  const _status = getters.cartItems.length ? status.ideal : status.empty;
  commit('setStatus', _status);
};


export default createStore({
  state: {
    cart: {},
    extraData: [],
    status: status.empty,
    updateIds: [],
    updateLine: 0,
  },

  getters: {
    isCartReady: state => [status.ideal, status.empty].includes(state.status),
    cartItems: state => state.cart.items || []
  },

  mutations: {
    setCart(state, cart) {
      state.cart = cart;
    },

    addCartItem(state, items) {
      state.cart.items.splice(0, 0, ...items);
    },

    setExtraData(state, extraData) {
      state.extraData = extraData
    },

    setUpdateIds(state, ids) {
      state.updateIds = ids;
    },

    setStatus(state, status) {
      state.status = status;
    },
    
    setUpdateLine(state, lines) {
      state.updateLine = lines;
    },

    /*setUpdateLine(state, payload) {
      if (payload === null || payload === undefined) {
        state.updateLine = 0;
      } else if (typeof payload === 'object' && payload.line != null) {
        state.updateLine = payload.line;
      } else {
        state.updateLine = payload;
      }
    },*/
  },

  actions: {
    async init({ commit, getters }, s1 = status.progress) {
      await commit('setStatus', s1);
      
      await req(fetch).then(data => afterReq(data, commit, getters));
      await req(fetchExtraData).then(extraData => commit('setExtraData', extraData));
      return true;
    },

    async initReplo({ commit, getters }, s1 = status.adding) {
      await commit('setStatus', s1);
      
      await req(fetch).then(data => afterReq(data, commit, getters));
      await req(fetchExtraData).then(extraData => commit('setExtraData', extraData));
      return true;
    },

    async add({ commit, dispatch, getters }, data) {
      if (getters.isCartReady) {
        await commit('setStatus', status.adding);
        await req(add, data).then(async() => await dispatch('init', status.adding));
        return true;
      }
    },

    async change({ commit, getters }, data) {
      const { noStateUpdate, cb } = data;
      delete data.cb;
      
      if (getters.isCartReady || noStateUpdate) {
        if (!noStateUpdate) {
          await commit('setUpdateLine', data.line);
          await commit('setStatus', status.progress);
        } else {
          delete data.noStateUpdate;
        }
        
        // Update cart with change request
        await req(change, data).then(async data => {
          await afterReq(data, commit, getters);
          
          // Fetch extra data to ensure enrichData is up-to-date
          await req(fetchExtraData).then(extraData => {
            commit('setExtraData', extraData);
          });
          
          // Reset update line and call callback
          if (!noStateUpdate) {
            await commit('setUpdateLine', 0);
          }
          cb && cb();
        });
        
        return true;
      }
    },

    async update({ commit,dispatch, getters }, data) {
      if (getters.isCartReady) {
        await commit('setUpdateLine', data);
        await commit('setStatus', status.progress);
        await req(update, data).then(async () => {
          await dispatch('init', status.progress);
        });
        return true;
      }
    },

    updateNote({ commit, getters }, note) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(updateNote, note).then(data => afterReq(data, commit, getters));
      }
    },

    clear({ commit, getters }) {
      if (getters.isCartReady) {
        commit('setStatus', status.progress);
        req(clear).then(data => afterReq(data, commit, getters));
      }
    }
  }
});